import React from "react";
import { PageLayout } from "layouts";
import { EmptyMessage, HeaderMain, Footer, LoadingSpinner } from "shared";
import parse from "html-react-parser";
import { useSettings } from "..";

export const Terms = () => {
  const { settingsInfo } = useSettings({ load: true, key: "page_terms" });
  const { data, isLoading } = settingsInfo;

  if (isLoading) return <LoadingSpinner />;

  return (
    <div id="main" className="layout-navbar">
      <HeaderMain />
      <div id="main-content">
        <PageLayout title={"Terms and Conditions"}>
          {data && (data !== "" || data !== null) ? (
            <div className="mb-5 text-dark">{parse(data.content)}</div>
          ) : (
            <div>
              <EmptyMessage
                heading={"No Terms and Conditions found"}
                subHeading={"There is no Terms and Conditions."}
              />
            </div>
          )}
        </PageLayout>
      </div>
      <Footer />
    </div>
  );
};
